export const environment = {
  production: true,
  URL_API: 'https://hpkny3enb7x7rda5lmqalbotfq0oehvk.lambda-url.eu-west-1.on.aws/api/v1/',
  idleTimeInMinutes: 60
};
